import React, { FC } from 'react'
import GetHelpCard from './GetHelpCard'

interface IToolsHeader {}
const ToolsHeader: FC<IToolsHeader> = () => {
  return (
    <div className="sm:flex justify-between pb-2 items-start mt-4 mb-16 sm:mt-0 sm:mb-0">
      <h1 className="font-fatfrank text-2xl sm:text-4xl text-black font-black">
        Access your tools in one command center!
      </h1>
      <div className="hidden sm:block">
        <GetHelpCard />
      </div>
    </div>
  )
}

export default ToolsHeader
